import { useMemo } from 'react';
import { Path } from 'react-hook-form';

import { EstateInclusionStatus } from '../TaxStatusSubform.types';

interface UseTaxStatusAssetLocationOptionsInput {
  fieldNamePrefix: string;
}

interface TaxStatusAssetLocationSubformCommonShape {
  estateInclusionStatus: EstateInclusionStatus;
}

type AssetLocationSubformShape<
  T extends UseTaxStatusAssetLocationOptionsInput,
> =
  | Record<T['fieldNamePrefix'], TaxStatusAssetLocationSubformCommonShape>
  | undefined;

export function useTaxStatusAssetLocationOptions({
  fieldNamePrefix,
}: UseTaxStatusAssetLocationOptionsInput) {
  const assetLocationOptions = useMemo(() => {
    const federalTaxOption = {
      label: 'Federal',
      fieldName:
        `${fieldNamePrefix}.estateInclusionStatus` as const satisfies Path<
          AssetLocationSubformShape<UseTaxStatusAssetLocationOptionsInput>
        >,
      options: [
        {
          label: '',
          value: 'in-estate',
        },
        {
          label: '',
          value: 'out-of-estate',
        },
      ],
    };

    return [federalTaxOption];
  }, [fieldNamePrefix]);

  return { assetLocationOptions };
}
